import gql from "graphql-tag";

import { ENTITY_VALUES_FRAGMENT } from "@arachnys/flow-app/src/page/EntityDetail/queries";

export const GET_TASK_DATA = gql`
    query GetTaskDataQuery($id: ID!) {
        node(id: $id) {
            ... on Task {
                componentName
                status
                assignable

                title
                userInstructions
                inputs

                owner {
                    id
                }

                process {
                    uid
                    flowClass
                }

                rootProcess {
                    uid
                    flowClass
                }

                entity {
                    ...EntityValues
                }

                properties {
                    edges {
                        node {
                            name
                            value
                        }
                    }
                }
                commentTags
            }
        }
    }
    ${ENTITY_VALUES_FRAGMENT}
`;
